export const getFirstForm = (parent: Element): HTMLFormElement => {
    const forms = parent.getElementsByTagName(`form`);
    const form = forms[0];

    if (!form) {
        throw new Error(`Missing "form" element.`);
    }

    return form;
};
